import { useCallback, useEffect, useState } from 'react';
import alert from '../../helpers/alert';

const LABELS = {
  mark: {
    add: 'Добавить марку',
    title: 'Новая марка',
    fieldLabel: 'Название марки',
    placeholder: 'Например, BYD',
    success: 'Марка добавлена',
  },
  model: {
    add: 'Добавить модель',
    title: 'Новая модель',
    fieldLabel: 'Название модели',
    placeholder: 'Например, Song Plus',
    success: 'Модель добавлена',
  },
  complectation: {
    add: 'Добавить комплектацию',
    title: 'Новая комплектация',
    fieldLabel: 'Название комплектации',
    placeholder: 'Например, Flagship',
    success: 'Комплектация добавлена',
  },
};

/**
 * Заведение значения справочника прямо из селекта: кнопка «Добавить ...» в конце
 * списка открывает модалку, созданное сразу подставляется в поле.
 *
 * Созданное держим в extraOptions: бэк отдаёт список по фокусу и о новой записи
 * ещё не знает, а без неё в списке менеджер, переоткрыв селект, заведёт дубль.
 *
 * @param {boolean} enabled — включать ли добавление (только б/у-процесс)
 * @param {'mark'|'model'|'complectation'} kind — тексты кнопки и модалки
 * @param {Function} create — (name) => Promise<{ value, label }>
 * @param {Function} onChange — выставить значение поля (field.onChange из HookForm)
 * @param {Function} onChangeCustom — побочный эффект экрана на выбор значения
 * @param {*} resetKey — при смене сбрасывает созданные опции (сменили марку и т.п.)
 * @param {string} context — что уже выбрано, строкой в шапке модалки
 */
const useDictionaryCreator = ({ enabled, kind, create, onChange, onChangeCustom, resetKey, context }) => {
  const [extraOptions, setExtraOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setExtraOptions([]);
  }, [resetKey]);

  const close = useCallback(() => setIsOpen(false), []);

  const submit = useCallback(
    async (input) => {
      const name = (input || '').trim();
      if (!name) return;

      setSaving(true);
      try {
        const option = await create(name);
        setExtraOptions((prev) => [option, ...prev]);
        onChange?.(option);
        onChangeCustom?.(option);
        alert.success(LABELS[kind].success);
        setIsOpen(false);
      } catch (err) {
        alert.error(err?.response?.data?.errorMessage || err?.message || 'Не удалось добавить');
      } finally {
        setSaving(false);
      }
    },
    [create, kind, onChange, onChangeCustom]
  );

  return {
    extraOptions: enabled ? extraOptions : [],
    // Уходит в selectProps react-select — оттуда его читает MenuList.
    selectProps: enabled
      ? { isSearchable: true, addOptionLabel: LABELS[kind].add, onAddOption: () => setIsOpen(true) }
      : null,
    modalProps: {
      ...LABELS[kind],
      isOpen: Boolean(enabled && isOpen),
      onClose: close,
      onSubmit: submit,
      saving,
      context,
    },
  };
};

export default useDictionaryCreator;
